import isEmpty from 'lodash/isEmpty';
import { APP_IMG } from 'src/constants';
import styled from 'styled-components';

export const getAffiliate = (_position, _data) => {
  if (isEmpty(_data) || !_data) return null;
  const item = Array.isArray(_data) && _data.filter(_item => _item.position === _position)[0];
  return (
    item && (
      <Affaliate className='content-detail text-align-center'>
        <a href={item?.link} title={item?.title} target='_blank' rel='noreferrer noopener nofollow'>
          {item.image ? (
            <img className='affaliate-image' src={`${APP_IMG}${item?.image}`} alt={item.title || `affaliate-${_position}`} title={item?.title} width='100%' height='100%' />
          ) : (
            <div className='btn-affaliate my-3' style={{ background: `${item?.bgColor}`, color: `${item?.textColor}` }}>
              {item?.title}
            </div>
          )}
        </a>
      </Affaliate>
    )
  );
};

const Affaliate = styled.div`
  .affaliate-image {
    width: 80% !important;
  }
`;
